<template>
  <v-row>
    <v-col cols="12" v-if="$store.state.accounts.retrieveLoader">
      <v-skeleton-loader class="mt-5" transition="fade-transition" type="list-item-three-line" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Pagos por transferencia</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row class="py-6">
            <v-col md="9">
              <v-list class="v-list-form transparent">
                <v-list-item class="my-3">
                  <v-list-item-title>
                    Mostrar extracto de cuenta bancaria
                    <v-tooltip right max-width="280px" transition="scale-transition">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                      </template>
                      <span>Mostrar en el portal de pagos el extracto con los datos de cuenta bancaria para recibir transferencias.</span>
                    </v-tooltip>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <v-col id="it-plan-frequency" cols="8">
                      <v-switch class="mt-n4" v-model="accountBankStatement.display_bank_statement" style="position: absolute" />
                    </v-col>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="my-3 align-top">
                  <v-list-item-title>Extracto de cuenta bancaria</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-textarea class="pb-0" v-model="$v.accountBankStatement.bank_statement.$model" :error="$v.accountBankStatement.bank_statement.$error" auto-grow solo flat outlined hide-details placeholder="Escribe los datos de la cuenta de banco donde recibes transferencias" />
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="patchAccount" :loading="$store.state.accounts.createLoader" color="primary">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { requiredIf } from 'vuelidate/lib/validators'
import ListViewMixin from '@/mixins/ListViewMixin'

export default {
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    accountBankStatement: {
      display_bank_statement: false,
      bank_statement: ''
    }
  }),
  created () {
    this.$store.dispatch('accounts/RETRIEVE', {
      resource: 'accounts',
      id: this.account.id
    })
    .then((response) => {
      this.accountBankStatement.display_bank_statement = response.data.display_bank_statement
      this.accountBankStatement.bank_statement = response.data.bank_statement
    })
  },
  methods: {
    patchAccount () {
      this.$v.accountBankStatement.$touch()
      if (this.$v.accountBankStatement.$invalid) {
        return false
      }
      this.$store.dispatch('accounts/UPDATE', {
        resource: 'accounts',
        payload: {
          display_bank_statement: this.accountBankStatement.display_bank_statement,
          bank_statement: this.accountBankStatement.bank_statement
        },
        id: this.account.id
      })
      .then(() => {
        this.$dialog.message.info('Las preferencias se han actualizado')
      })
      .catch((error) => {
        this.$dialog.message.warning(this.parseErrors(error.response.data))
      })
    }
  },
  validations: {
    accountBankStatement: {
      bank_statement: {
        required: requiredIf(function () {
          return this.accountBankStatement.display_bank_statement
        })
      }
    }
  }
}
</script>